//Library Imports
import React, { useEffect, useState } from "react";
import { Col, Row, Tooltip, Typography } from "antd";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory, useLocation, useParams } from "react-router-dom";

//Local Imports
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import Add from "../../../../assets/img/CuratedContent/Plus.svg";
import Import from "../../../../assets/img/icons/Import_grey.svg";
import Send from "../../../../assets/img/CuratedContent/Send.svg";
import BackIcon from "../../../../assets/img/icons/Icon_back.svg";
import { ReactComponent as FiltersIcon } from "../../../../assets/img/icons/FiltersIcon.svg";
import { closeOverlay, GLOBAL_ACTION, openCreateNewContactSidebar, setAudienceFilterApplied } from "modules/GlobalActions";
import { applySelectedFiltersListDetails, exportListDetails, resetAudienceFilterToggle, resetAudienceListDetailsProfiled, resetAudiencePeopleTabData, setAudienceFilterToggle } from "./actions";
import { removeGillRoyIcon, getQueryListId } from "utils";
import ExportPopup from "../Components/ExportPopup";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import CreateContactSidebar from "../People/CreateContactSidebar";
import FilterDropdownOrganization from "../People/FilterDropdownOrganization";
import FilterDropdownDesignation from "../People/FilterDropdownDesignation";
import FilterDropdownPersonality from "../People/FilterDropdownPersonality";
import FilterDropdownStatus from "../People/FilterDropdownStatus";
import { AUDIENCE_LISTS_DETAILS } from "constants/types";
import { PEOPLE_AUDIENCE } from "constants/actionTypes";
import AudienceSearchTab from "../Components/AudienceSearchTab";
import TotalCountLoader from "modules/Common/Components/TotalCountLoader";
import {
  resetAudienceListDetailsPeopleSearch
} from "../Lists/actions";
import { getDesignations, getOrganizations } from "../actions";
import { PageParams } from "modules/Campaigns/AssetsWithOutCampaigns/Components/AssetsWithoutCampaignTab";

interface IListDetailsTab {
  tabState: any;
  showImportListAsider: boolean;
  setShowImportListAsider: (arg0: boolean) => void;
  updateTotalCount?: boolean;
  setUpdateTotalCount: (arg0: boolean) => void;
  selectedOrganization: string[];
  setSelectedOrganization: (arg0: string[]) => void;
  selectedDesignation: string[];
  setSelectedDesignation: (arg0: string[]) => void;
  selectedPersonalityType: string[];
  setSelectedPersonalityType: (arg0: string[]) => void;
  selectedStatus: string[];
  setSelectedStatus: (arg0: string[]) => void;
  resetFilters: () => void;
  clearFiltersCheck: boolean;
  setClearFiltersCheck: (arg0: boolean) => void;
  clearFiltersHandler: (reloadAudience?: boolean) => void;
  exportContactsFilterParams: any;
  exportPeopleFiltersUpdate: () => void;
  page: string;
  addPeopleMode: boolean;
  handleAddPeopleMode: (mode: boolean, addGlobalContactMode?: boolean) => void;
  addGlobalPeopleMode?: boolean;
}

const { Paragraph } = Typography;

const ListDetailsTab: React.FC<IListDetailsTab> = ({
  tabState,
  showImportListAsider,
  setShowImportListAsider,
  updateTotalCount,
  setUpdateTotalCount,
  selectedOrganization,
  setSelectedOrganization,
  selectedDesignation,
  setSelectedDesignation,
  selectedPersonalityType,
  setSelectedPersonalityType,
  selectedStatus,
  setSelectedStatus,
  clearFiltersHandler,
  exportContactsFilterParams,
  exportPeopleFiltersUpdate,
  page,
  addPeopleMode,
  handleAddPeopleMode,
  addGlobalPeopleMode
}) => {
  //Local States
  const history = useHistory();
  const { pathname } = useLocation();
  const { subTab } = useParams<PageParams>();
  const [showCreateContactFormState, setshowCreateContactFormState] = useState(false);
  const [closeSidebarInstantly, setCloseSidebarInstantly] = useState(true);
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);
  const [exportDisable, setExportDisable] = useState(false);

  // disable import in case of add people screen on list details
  const disableImport = subTab === 'add';

  //Redux States
  const listName = useSelector((state: RootState) => state.audienceListDetails.listName);
  const campaignsAndAssetsCount = useSelector(
    (state: RootState) => state.audienceListDetails.campaignsAndAssetsCount
  );
  const totalContacts = useSelector((state: RootState) => state.audienceListDetails.totalContacts);
  const profiledLoading: boolean = useSelector((state: RootState) => state.audienceListDetails.profiled.loading);
  const profiled: any = useSelector((state: RootState) => state.audienceListDetails.profiled.data);
  const nonProfiled: any = useSelector((state: RootState) => state.audienceListDetails.nonProfiled.data);
  const nonProfiledLoading: boolean = useSelector(
    (state: RootState) => state.audienceListDetails.nonProfiled.loading
  );
  const showCreateContactForm = useSelector((state: RootState) => state.audience.showCreateContactForm);
  const disableExportButton = useSelector((state: RootState) => state.audienceLists.exportLoading);
  const audienceFiltersApplied: boolean = useSelector(
    (state: RootState) => state.uiReducer.audienceFiltersApplied
  );
  const searchTermListContacts = useSelector(
    (state: RootState) => state.audienceListDetails.searchTermListDetails
  );
  const showFilterToggle = useSelector((state: RootState) => state.audience.showFilterToggle)
  // Global Listing States
  const totalCount = useSelector((state: RootState) => state.peopleAudience.totalCount);
  const allPeopleLoading: boolean = useSelector((state: RootState) => state.peopleAudience.allPeopleLoading);
  const allPeoplePage: number = useSelector((state: RootState) => state.peopleAudience.allPeoplePage);
  const allPeople = useSelector((state: RootState) => state.peopleAudience.allPeople);

  const importListButtonHandler = () => {
    setShowImportListAsider(!showImportListAsider);
    store.dispatch({
      type: GLOBAL_ACTION.IMPORT_LIST_POPOVER,
      payload: { importListAsiderState: true },
    });
    if (window.location.pathname.startsWith("/audiences")) {
      removeGillRoyIcon();
    }
  };

  const closeSidebarInstantlyHandler = (showCreateContactForm: boolean) => {
    setshowCreateContactFormState(showCreateContactForm);
    closeOverlay();
  };

  useEffect(() => {
    if (!firstTimeLoad) {
      if (!showCreateContactForm) {
        closeSidebarInstantly
          ? closeSidebarInstantlyHandler(showCreateContactForm)
          : setshowCreateContactFormState(showCreateContactForm);
      } else {
        setshowCreateContactFormState(showCreateContactForm);
      }
    } else {
      setFirstTimeLoad(false);
    }
  }, [showCreateContactForm]);

  useEffect(() => {
    if (
      (profiled.length <= 0 && profiledLoading) ||
      (nonProfiled.length <= 0 && nonProfiledLoading) ||
      disableExportButton
    )
      setExportDisable(true);
    else if (totalContacts > 0) setExportDisable(false);
    else setExportDisable(true);
  }, [profiledLoading, nonProfiledLoading, disableExportButton, totalContacts]);

  useEffect(() => {
    setUpdateTotalCount(true);
    store.dispatch({
      type: AUDIENCE_LISTS_DETAILS.RESET_TOTAL_COUNT,
    });
  }, [tabState]);

  useEffect(() => {
    if (updateTotalCount) {
      setUpdateTotalCount(false);
    }
  }, [totalContacts]);

  useEffect(() => {
    if (!profiledLoading && updateTotalCount) setUpdateTotalCount(false);
  }, [profiledLoading]);

  // To set addPeople mode back to default
  // useEffect(() => {
  //   if (pathname.includes("all") && !addPeopleMode) {
  //     handleAddPeopleMode(true)
  //   }
  //   else if (!pathname.includes("all") && addPeopleMode) {
  //     handleAddPeopleMode(false)
  //   }
  // }, [pathname]);

  // To set addPeople mode back to default
  useEffect(() => {
    if (pathname.includes("all") && !addPeopleMode) {
      handleAddPeopleMode(true)
    }
    else if (pathname.includes("add") && !addGlobalPeopleMode) {
      handleAddPeopleMode(true, true)
    }
    else if ((!pathname.includes("all") && !pathname.includes("add"))) {
      handleAddPeopleMode(false, false)
    }
  }, [pathname]);

  const ApplyFiltersHandler = () => {
    resetAudienceListDetailsProfiled(); // reset contacts in list
    exportPeopleFiltersUpdate();
    applySelectedFiltersListDetails({
      designations: selectedDesignation,
      organizations: selectedOrganization,
      personality: selectedPersonalityType,
      status: selectedStatus,
    })
    store.dispatch({
      type: GLOBAL_ACTION.APPLY_AUDIENCE_FILTERS,
    });
    if (!audienceFiltersApplied) {
      setAudienceFilterApplied(true);
    }
  };

  const handleApplyFiltersBothLists = () => {
    if (tabState === "profiled") {
      resetAudiencePeopleTabData(); // reset all people tab data
    }
    resetAudienceListDetailsProfiled(); // reset contacts in list
    exportPeopleFiltersUpdate();
    let newAudienceFilters = {
      designations: selectedDesignation,
      organizations: selectedOrganization,
      personality: selectedPersonalityType,
      status: selectedStatus,
    }
    applySelectedFiltersListDetails(newAudienceFilters);
    store.dispatch({
      type: PEOPLE_AUDIENCE.SET_FILTERS,
      payload: newAudienceFilters,
    });
    store.dispatch({
      type: GLOBAL_ACTION.APPLY_AUDIENCE_FILTERS,
    });
    if (!audienceFiltersApplied) {
      setAudienceFilterApplied(true);
    }
  }

  const handleToggleFilters = () => {
    if (showFilterToggle) {
      resetAudienceFilterToggle();
    }
    else {
      setAudienceFilterToggle();
    }
  };

  const handleNavigateBack = () => {
    resetAudienceListDetailsPeopleSearch();
    clearFiltersHandler(false);
    handleAddPeopleMode(false, false);
    history.push(`/audiences/lists/view${window.location.search}`)
  }

  useEffect(() => {
    if (window.location.pathname === "/audiences/lists/view") {
      resetAudiencePeopleTabData()
      console.log("Clear")
    }
  }, [])

  return (
    <Wrapper toggleFilters={showFilterToggle} selectedFilters={(selectedOrganization.length > 0 ||
      selectedDesignation.length > 0 ||
      selectedPersonalityType.length > 0 ||
      selectedStatus.length > 0) ?? false}>
      <Row className="justify-content-between">
        <Col span={14} className="audience-list-search">
          <AudienceSearchTab page={page} isProfiled={true} addPeopleMode={addPeopleMode} handleAddPeopleMode={handleAddPeopleMode} />
        </Col>
        <Col className="gutter-row" span={10}>
          <div
            className="d-flex flex-row-reverse ant-space ant-space-horizontal ant-space-align-center"
            style={{ height: "100%" }}
          >

            {addGlobalPeopleMode && (
              <span
                onClick={() => handleNavigateBack()}
                className="onLinerBtn"
              >
                <ButtonRightIconGreen
                  label="Go Back"
                  icon={BackIcon}
                  iconStart={true}
                  classIcon="plus15"
                  className="people-green-btn"
                  idBtn="people-green-btn-contact"
                />
              </span>
            )}

            {!addPeopleMode && (<span onClick={() => { handleAddPeopleMode(true, true); history.push(`/audiences/lists/view/add/${window.location.search}`) }} className="onLinerBtn">
              <ButtonRightIconGreen
                label="Add contact"
                icon={Add}
                classIcon="plus15"
                className="people-green-btn"
                idBtn="people-grfen-btn-contact"
              />
            </span>
            )}

            <span onClick={() => openCreateNewContactSidebar()} className="me-3">
              <ButtonRightIconGreen
                label="Create new contact"
                icon={Add}
                classIcon="plus15"
                className="list-green-btn"
                idBtn="list-green-btn-contact"
              />
            </span>
            <Tooltip placement="bottom" title={'Import'}>
              <IconBtn
                className={`exportBtn miniBtn ${disableImport ? "disable" : ""}`}
                onClick={() => {
                  if (disableImport) return;
                  importListButtonHandler();
                }}>
                <img className="export-icon" src={Import} alt="ImportIcon" />
              </IconBtn>
            </Tooltip>
            <Tooltip placement="bottom" title={'Export'}>
              <IconBtn
                className={`exportBtn miniBtn ${exportDisable ? "disable" : ""}`}
                onClick={() => {
                  if (exportDisable) return;
                  exportListDetails(
                    {
                      export: true,
                      profiled: tabState === "profiled" ? "1" : "0",
                      ...exportContactsFilterParams,
                      searchTermListContacts: searchTermListContacts,
                    },
                    getQueryListId()
                  );
                }}
              >
                <img className="export-icon" src={Send} alt="ExportIcon" />
              </IconBtn>
            </Tooltip>
            <Tooltip placement="bottom" title={'Filters'}>
              <IconBtn
                className={`exportBtn miniBtn`}
                onClick={() => {
                  handleToggleFilters();
                }}
              >
                <FiltersIcon className="filterBtn" />
              </IconBtn>
            </Tooltip>
          </div>
        </Col>
      </Row>

      <Row gutter={12} className="mt-3 filter-row">
        <Col span={9} className="first-col">
          <Col span={24} className="" >
            {addGlobalPeopleMode ?
              (
                <>
                  {(allPeopleLoading && allPeople.length === 0) || (allPeoplePage === 0 && totalCount === 0) ? (
                    <div className="d-flex count"><TotalCountLoader width={200} height={30} /></div>
                  ) : (
                    <div className="d-flex count">
                      <Paragraph className="list-name">
                        Audience
                      </Paragraph>
                      <span style={{ marginLeft: '8px' }}>{`(${totalCount})`}</span>
                    </div>
                  )}
                </>
              ) : updateTotalCount || (profiledLoading && profiled.length === 0) || (profiledLoading && totalContacts === 0) ? (
                <div className="d-flex count"><TotalCountLoader width={200} height={33} /></div>
              ) : (
                <div className="d-flex count">
                  <Paragraph className="list-name" ellipsis={{ rows: 1, expandable: false, tooltip: listName }}>
                    {listName}
                  </Paragraph>
                  <span style={{ marginLeft: '8px' }}>{`(${totalContacts})`}</span>
                </div>
              )
            }
          </Col>
        </Col>

        <Col className="second-col" span={15} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', paddingRight: '20px' }}>
          <Col className="filters-visibility" span={2.5}>
            <FilterDropdownOrganization
              selectedOrganization={selectedOrganization}
              setSelectedOrganization={setSelectedOrganization}
              fetchData={getOrganizations}
            />
          </Col>
          <Col className="filters-visibility" span={2.5}>
            <FilterDropdownDesignation
              selectedDesignation={selectedDesignation}
              setSelectedDesignation={setSelectedDesignation}
              fetchData={getDesignations}
            />
          </Col>
          <Col className="filters-visibility" span={2.5}>
            <FilterDropdownPersonality
              selectedPersonalityType={selectedPersonalityType}
              setSelectedPersonalityType={setSelectedPersonalityType}
            />
          </Col>
          <Col className="filters-visibility" span={2.5}>
            <FilterDropdownStatus selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} />
          </Col>

          <Col span={2.5}>
            <ButtonRightIconGreen
              onClick={addPeopleMode ? handleApplyFiltersBothLists : ApplyFiltersHandler}
              label="Apply Filters"
              marginTop="0px"
              noIcon
              className={`${!(
                selectedOrganization.length > 0 ||
                selectedDesignation.length > 0 ||
                selectedPersonalityType.length > 0 ||
                selectedStatus.length > 0
              ) ? "disabled-filter" : ""} list-apply-filters filters-visibility`}
            />
          </Col>
          <Col
            span={2.5}
            className={`${!(
              selectedOrganization.length > 0 ||
              selectedDesignation.length > 0 ||
              selectedPersonalityType.length > 0 ||
              selectedStatus.length > 0 ||
              audienceFiltersApplied
            ) ? "disabled-filter" : ""} clear-text filters-visibility`}
          >
            <span onClick={clearFiltersHandler}>Clear all</span>
          </Col>
        </Col>

      </Row>

      <ExportPopup listId={getQueryListId()} />
      <FloatingSidebarTwo isToggle={showCreateContactFormState}>
        <CreateContactSidebar
          selectedTab={"profiled"}
          setCloseSidebarInstantly={setCloseSidebarInstantly}
          listId={getQueryListId()}
        />
      </FloatingSidebarTwo>
    </Wrapper>
  );
};

export default React.memo(ListDetailsTab);

const Wrapper = styled.div.attrs((props: { toggleFilters: boolean; selectedFilters: any }) => props)`
  margin-top: 0px;
  /* margin-bottom: 10px; */
  .filter-row {
    position: relative;
    .count-col {
      position: absolute;
      right: 0;
      margin-top: 5px;
      /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 0px;
      } */
    }
    .filters-visibility {
      ${(props) => (props.toggleFilters ? `visibility: visible` : `visibility: hidden`)}
    }
    .first-col {
      @media all and (max-width: 1200px) {
        flex: 0 0 25.5%;
        max-width: 25.5%;
      }
      @media all and (max-width: 1100px) {
        flex: 0 0 20.5%;
        max-width: 20.5%;
      }
    }
    .second-col {
      @media all and (max-width: 1200px) {
        flex: 0 0 74.5%;
        max-width: 74.5%;
        padding-right: 0px !important;
      }
      @media all and (max-width: 1100px) {
        flex: 0 0 79.5%;
        max-width: 79.5%;
      }
    }
  }
  .filterBtn {
    /* color: #7e7e7e; */
    ${(props) => (props.selectedFilters ? "color: #1EC252;" : "color: #7e7e7e;")}
  }
  .list-name{
    color: #5e7079;
    margin-bottom: 0px;
  }
  .clear-text {
    color: #7e7e7e;
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }

  .disabled-filter {
    pointer-events: none;
    opacity: 0.5;
  }
  .campaign-asset-count-text {
    font-size: 23px;
    font-weight: 700;
    font-family: "Roboto Slab", serif;
    display: inline-block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #424b50;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .total-count {
    height: 100%;
    align-items: center;
    color: #7e7e7e;
    font-family: "Roboto Slab", serif;
    font-size: 16px;
    font-weight: 500;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .count {
    align-items: center;
    color: #5e7079;
    font-family: "Roboto Slab", serif;
    font-size: 22.5px;
    font-weight: 700;

    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 20.5px;
    }
  }
  .plus-btn {
    margin-top: 0px;
  }
  .filters-tabs {
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      li {
        margin: 0px;
        padding: 0;

        &:nth-child(1) {
          button {
            border-radius: 8px 0px 0px 8px;
            .wrapper {
              border-radius: 8px 0px 0px 8px;
            }
          }
        }
        &:nth-child(2) {
          button {
            border-radius: 0 8px 8px 0;
            .wrapper {
              border-radius: 0 8px 8px 0;
            }
          }
        }
      }
    }
  }
  .list-green-btn {
    white-space: nowrap;
  }
  /* .list-green-btn {
    width: 202px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 168px;
    }
    @media all and (max-width: 1125px) {
      height: 26px;
    }
  } */
  .audience-list-search {
    .search-wraper {
      .search-bar {
        width: calc(100% - 25px);
        @media all and (max-width: 1700px) {
          width: calc(100% - 50px);
        }
        @media all and (max-width: 1650px) {
          width: calc(100% - 75px);
        }
        @media all and (max-width: 1550px) {
          width: calc(100% - 120px);
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: calc(100% - 100px);
        }
        @media all and (max-width: 1260px) {
          width: calc(100% - 140px);
        }
      }
    }
  }
  .list-apply-filters {
    padding: 5px 2px 5px 16px;
  }
  .onLinerBtn{
    min-width: fit-content;
  }
  .miniBtn{
    min-width:30px;
  }
`;

const IconBtn = styled.span`
  height: 31px;
  width: 30px;
  margin-right: 20px;
  margin-top: 1px;
  cursor: pointer;
  background: #ffffff;
  border: 0.946496px solid #dadada;
  border-radius: 7.75399px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 30px;
  }
  .export-icon {
    width: 14px;
    margin-left: 2px;
  }
  &.disable {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
